// extracted by mini-css-extract-plugin
export default {"goesOnSaleLabel":"Rxn5fU","onSaleLabel":"Di37q4"};